<section class="arrow-down-box">
  <img [src]="imageSrc" [alt]="alt" />
</section>
